module.exports = "<div id=\"loader\">\n  <div class=\"logo\">\n    <img src=\"assets/img/logo_rf2.png\">\n  </div>\n  <canvas #canvas></canvas>\n</div>\n"